import React, { useState, useEffect, useCallback, useMemo } from "react";
import TaxRateField from "../shared/TaxRateField";
import ApplyTaxCheckboxGroup from "../shared/ApplyTaxCheckboxGroup";
import { useTaxData, useUpdateStateTax } from "../../hooks/useTaxQueries";

const StateTaxRatesSection = ({ taxState, isLoading, styles }) => {
  const { data: taxData } = useTaxData(taxState);
  const updateStateTaxMutation = useUpdateStateTax();

  const applyTaxes = useMemo(
    () => ({
      state: taxData?.applyStateTaxToOneTimeFee || false,
      county: taxData?.applyCountyTaxToOneTimeFee || false,
      other: taxData?.applyOtherStateTaxToOneTimeFee || false,
      use: taxData?.applyUseStateTaxToOneTimeFee || false,
    }),
    [taxData],
  );

  const handleSaveStateTax = useCallback(
    (body) => {
      if (taxData?._id) {
        updateStateTaxMutation.mutate({ ...body, id: taxData._id });
      }
    },
    [taxData, updateStateTaxMutation],
  );

  const handleApplyTaxChange = useCallback(
    (taxType, checked) => {
      const fieldMap = {
        state: "applyStateTaxToOneTimeFee",
        county: "applyCountyTaxToOneTimeFee",
        other: "applyOtherStateTaxToOneTimeFee",
        use: "applyUseStateTaxToOneTimeFee",
      };

      handleSaveStateTax({ [fieldMap[taxType]]: checked });
    },
    [handleSaveStateTax],
  );

  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>State Tax Rates</h3>

      <div className={styles.formRow}>
        <TaxRateField
          label="State Tax Rate (%)"
          value={taxData?.stateTaxRate || 0}
          onSave={(value) => handleSaveStateTax({ stateTaxRate: value })}
          isLoading={isLoading}
          disabled={!taxState}
        />

        <TaxRateField
          label="State Use Tax (%)"
          value={taxData?.stateUseTax || 0}
          onSave={(value) => handleSaveStateTax({ stateUseTax: value })}
          isLoading={isLoading}
          disabled={!taxState}
        />

        <TaxRateField
          label="State Other Tax (%)"
          value={taxData?.stateOtherTax || 0}
          onSave={(value) => handleSaveStateTax({ stateOtherTax: value })}
          isLoading={isLoading}
          disabled={!taxState}
        />

        <ApplyTaxCheckboxGroup
          taxState={taxState}
          values={applyTaxes}
          onChange={handleApplyTaxChange}
        />
      </div>
    </div>
  );
};

export default StateTaxRatesSection;
